var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pipeline-step",
      class: _vm.classes,
      on: {
        click: function() {
          return !_vm.isPaginated ? _vm.handleUpdate() : null
        }
      }
    },
    [
      !_vm.isPaginated
        ? _c(
            "CompassTooltip",
            { attrs: { arrow: false, contentClass: "pipeline-step__tooltip" } },
            [
              _c("span", {
                attrs: { slot: "content" },
                domProps: { innerHTML: _vm._s(_vm.tooltipContent) },
                slot: "content"
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pipeline-step__wrapper" },
                [
                  !_vm.finished
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "pipeline-step__label typographies-paragraph-small-regular"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.step.name) +
                              "\n            "
                          )
                        ]
                      )
                    : _c("CompassIcon", {
                        attrs: { icon: "check", size: "small" }
                      })
                ],
                1
              )
            ]
          )
        : _c(
            "div",
            { staticClass: "pipeline-step__wrapper" },
            [
              _c(
                "CompassMenu",
                {
                  attrs: {
                    trigger: "hover",
                    size: "small",
                    placement: "bottom"
                  }
                },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "ellipsis", size: "extra-small" }
                  }),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "dropdown" },
                    _vm._l(_vm.step, function(subStep) {
                      return _c("CompassMenuItem", {
                        key: subStep.id,
                        attrs: { label: subStep.name },
                        on: {
                          click: function($event) {
                            return _vm.handleUpdate(subStep)
                          }
                        }
                      })
                    }),
                    1
                  )
                ],
                2
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }